import React from 'react';

const SubmitButton = ({
  isLoading = false,
  disabled = false,
  label = 'Submit',
  loadingLabel = 'Sending…',
  block = false,
  className = '',
}) => (
  <>
    {/*
      Invisible honeypot. Real users never type into a field positioned
      off-screen with no label; bots that crawl the DOM fill every input
      and trip the check in useContactForm.handleSubmit. autoComplete=off
      keeps password managers from auto-filling it.
    */}
    <input
      type="text"
      name="website"
      tabIndex={-1}
      autoComplete="off"
      defaultValue=""
      className="tf-honeypot"
      aria-hidden="true"
    />
    <button
      type="submit"
      className={`tf-submit${block ? ' tf-submit--block' : ''} ${className}`.trim()}
      disabled={isLoading || disabled}
      aria-busy={isLoading || undefined}
    >
      {isLoading ? (
        <>
          <span className="tf-submit__spinner" aria-hidden="true" />
          {loadingLabel}
        </>
      ) : label}
    </button>
  </>
);

export default SubmitButton;
